import type {
  PickPagePagesQueryResponse,
  PickPagePagesQueryVariables,
} from '~/api/shopify/queries/pickPagePages.generated';
import type { PickPagePageNodeFragment } from '~/api/shopify/fragments/pickPagePage.generated';
import type { IPickPageSource, IPickPageSourceParams } from '../../types';

import {
  PICK_PAGE_IS_SORT_REVERSED,
  PICK_PAGE_SORT_KEY,
  PICK_PAGE_PAGE_SIZE,
} from '../../constants';
import { PickPagePagesDocument } from '~/api/shopify/queries/pickPagePages.generated';
import { usePickPageConnectionSource } from './usePickPageConnectionSource';
import { toPickPageItemFromPage, toPickPageSearchQuery } from '../../utils';

/** Shopify's "pages" are the landing pages — a blog's articles are listed apart from them. */
export const usePickPageLandingSource = ({
  searchValue,
  isEnabled,
  templateAssetKeys,
}: IPickPageSourceParams): IPickPageSource =>
  usePickPageConnectionSource<
    PickPagePagesQueryResponse,
    PickPagePagesQueryVariables,
    PickPagePageNodeFragment
  >({
    queryKey: 'pick-page-landing-infinity',
    document: PickPagePagesDocument,
    toVariables: (after?: string) => ({
      first: PICK_PAGE_PAGE_SIZE,
      query: toPickPageSearchQuery(searchValue),
      sortKey: PICK_PAGE_SORT_KEY,
      reverse: PICK_PAGE_IS_SORT_REVERSED,
      after,
    }),
    searchValue,
    isEnabled,
    templateAssetKeys,
    toConnection: (response) => response.pages,
    toItem: toPickPageItemFromPage,
  });
